import React from 'react';
import { useAuth } from '@/hooks/useAuth';
import { LoginForm } from '@/components/LoginForm';
import { Loader2, Database } from 'lucide-react';

interface AuthProviderProps {
  children: React.ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Database className="w-8 h-8 text-shiftleft-600" />
            <span className="text-2xl font-bold text-gray-900 dark:text-white">SqlHealthPro</span>
          </div>
          <Loader2 className="w-8 h-8 animate-spin mx-auto text-shiftleft-600" />
          <p className="mt-2 text-gray-600 dark:text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  // Show login form if not authenticated
  if (!isAuthenticated) {
    return <LoginForm />;
  }

  // Render children if authenticated
  return <>{children}</>;
}